// @flow
import React from 'react';
import moment from 'moment';

import { SiteContainer } from 'Components/frameworks/site-container/SiteContainer.jsx';
import * as CARD_LAYOUTS from 'Components/frameworks/card/Card.constants';
import { Card } from 'Components/frameworks/card/Card.jsx';

const ORIGINAL_DATE_FORMAT = 'DD/MM/YYYY';
const TARGET_DATE_FORMAT = 'DD MMMM YYYY';

function formatDate(startDate: string, endDate: string): string {
  return [startDate, endDate]
    .filter(Boolean)
    .map(date => moment(date, ORIGINAL_DATE_FORMAT).format(TARGET_DATE_FORMAT))
    .join(' - ');
}

function getCtaLabel(associatedProductLabel: string, productName: string): string {
  return productName ? `${associatedProductLabel} ${productName}`.trim() : '';
}

type Props = {
  associatedProductLabel: string,
  config: CMSContent,
  countryEvents: Array<{
    associatedProducts: Array<{
      name: string,
      url: string,
    }>,
    description: string,
    endDate: string,
    media: {
      mediaAlt: string,
      mediaUrl: string,
    },
    startDate: string,
    title: string,
  }>,
  id?: string,
  seeMoreLabel: string,
};

export function CountryEventsLine({
  associatedProductLabel,
  config: {
    common: { close },
  },
  countryEvents = [],
  id,
  seeMoreLabel,
}: Props) {
  const countryEventsCards = countryEvents.map(
    ({ associatedProducts = [], description, endDate, media, startDate, title }) => {
      const associatedProduct = associatedProducts.length > 0 ? associatedProducts[0] : {};

      return {
        closeLabel: close,
        ctaLabel: getCtaLabel(associatedProductLabel, associatedProduct.name),
        heading: {
          title,
          hLevel: 3,
        },
        introduction: {
          text: formatDate(startDate, endDate),
        },
        link: { url: associatedProduct.url },
        media: {
          alt: media ? media.mediaAlt : '',
          url: media ? media.mediaUrl : '',
        },
        text: {
          text: description,
          seeMoreLabel,
        },
        theme: 'landing',
      };
    },
  );

  if (countryEventsCards.length === 0) {
    return null;
  }

  return (
    <SiteContainer className="Line" id={id}>
      {countryEventsCards.length > 1 ? (
        <div className="sm:flex sm:flex-wrap -m-2">
          {countryEventsCards.map(countryEventCard => (
            <div className="sm:w-1/2 p-2" key={countryEventCard.heading.title}>
              <Card {...countryEventCard} layout={CARD_LAYOUTS.COLUMN_1} />
            </div>
          ))}
        </div>
      ) : (
        <Card {...countryEventsCards[0]} layout={CARD_LAYOUTS.COMPOSITE_1} />
      )}
    </SiteContainer>
  );
}
